import { types } from "../Helpers/Types";

const initialState = {
  modulos: [],
  menus: [],
  presas: [],
  autenticado: null,
  roles: []
};

export const SesionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.sesion: {
      return {
        modulos: action.payload.modulos,
        menus: action.payload.menus,
        presas: action.payload.presas,
        autenticado: action.payload.autenticado,
        roles: action.payload.roles
      };
    }

    default:
      return state;
  }
};
